<script>
    import Error from "./Error.svelte";
    
    export let url;
    export let name;
    export let image;
    export let language;
    export let description;
</script>

<a href="{url}">
    <div class="libro">
        <div class="top">
            {#if image}
                <img
                    on:error="{() => image = false}"
                    src="data/images/books/{image}"
                    class="image"
                    alt="Libro {name}"
                />
            {:else}
                <Error></Error>
            {/if}
        </div>
        <div class="bottom">
            <div class="details">
                <h1 class="title">{name}</h1>
                <p class="subtitle">Idioma: {language}</p>
                <p class="description">{description}</p>
            </div>
        </div>
    </div>
</a>

<style>
    a {
        color: inherit;
        text-decoration: inherit;
    }

    .libro {
        /** Component global variables */
        --card-corners: 5px;

        --img-width: 100%;
        --img-height: 100%;

        /** The object propeties */
        width: 100%;
        height: auto;

        border-radius: var(--card-corners);
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    }

    .top {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .image {
        width: var(--img-width);
        height: var(--img-height);
        
        border-radius: var(--card-corners) var(--card-corners) 0 0;
    }

    .bottom {
        max-width: var(--img-width);
        padding: 10px;
    }

    .details {
        display: grid;
        height: auto;
        
        row-gap: 2px;
        grid-template-rows: auto auto 1fr;
        grid-template-columns: minmax(calc(100% / 3), 1fr) auto;

        text-align: left;
    }

    .details > * {
        margin: 0.1px;
        word-break: break-word;
    }

    .title {
        grid-row: 1;
        grid-column: 1;
        margin: 0;

        word-break: break-word;
        font-size: 1.1rem;
    }

    .subtitle {
        grid-row: 2;
        grid-column: 1/3;
        font-size: 0.75rem;
        margin: 1% 0;
    }

    .description {
        grid-row: 3;
        grid-column: 1/3;

        width: 100%;
        margin: auto;

        text-align: center;
        word-break: break-word;
    }
</style>